import { buildTitle } from 'shared/components/Page'
import { APP_NAME } from '../constants'

export const buildResourceUrl: (path: string) => string = (path) =>
  `https://cawood.co.uk/resources/${path}`

export const getTitle = buildTitle(APP_NAME)
